function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { Controller } from "@hotwired/stimulus";
var optionSelector = "[role='option']:not([aria-disabled])";
var activeSelector = "[aria-selected='true']";

var Autocomplete = /*#__PURE__*/function (_Controller) {
  _inherits(Autocomplete, _Controller);

  var _super = _createSuper(Autocomplete);

  function Autocomplete() {
    var _this;

    _classCallCheck(this, Autocomplete);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.onKeydown = function (event) {
      var handler = _this["on".concat(event.key, "Keydown")];

      if (handler) handler(event);
    };

    _this.onEscapeKeydown = function (event) {
      if (!_this.resultsShown) return;

      _this.hideAndRemoveOptions();

      event.stopPropagation();
      event.preventDefault();
    };

    _this.onArrowDownKeydown = function (event) {
      var item = _this.sibling(true);

      if (item) _this.select(item);
      event.preventDefault();
    };

    _this.onArrowUpKeydown = function (event) {
      var item = _this.sibling(false);

      if (item) _this.select(item);
      event.preventDefault();
    };

    _this.onTabKeydown = function (event) {
      var selected = _this.selectedOption;
      if (selected) _this.commit(selected);
    };

    _this.onEnterKeydown = function (event) {
      var selected = _this.selectedOption;

      if (selected && _this.resultsShown) {
        _this.commit(selected);

        if (!_this.hasSubmitOnEnterValue) {
          event.preventDefault();
        }
      }
    };

    _this.onInputBlur = function () {
      if (_this.mouseDown) return;

      _this.close();
    };

    _this.onResultsClick = function (event) {
      if (!(event.target instanceof Element)) return;
      var selected = event.target.closest(optionSelector);
      if (selected) _this.commit(selected);
    };

    _this.onResultsMouseDown = function () {
      _this.mouseDown = true;

      _this.resultsTarget.addEventListener("mouseup", function () {
        _this.mouseDown = false;
      }, {
        once: true
      });
    };

    _this.onInputChange = function () {
      _this.element.removeAttribute("value");

      if (_this.hasHiddenTarget) _this.hiddenTarget.value = "";

      var query = _this.inputTarget.value.trim();

      if (query && query.length >= _this.minLengthValue) {
        _this.fetchResults(query);
      } else {
        _this.hideAndRemoveOptions();
      }
    };

    _this.fetchResults = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(query) {
        var url, html;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.hasUrlValue) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                url = _this.buildURL(query);
                _context.prev = 3;

                _this.element.dispatchEvent(new CustomEvent("loadstart"));

                _context.next = 7;
                return _this.doFetch(url);

              case 7:
                html = _context.sent;

                _this.replaceResults(html);

                _this.element.dispatchEvent(new CustomEvent("load"));

                _this.element.dispatchEvent(new CustomEvent("loadend"));

                _context.next = 18;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](3);

                _this.element.dispatchEvent(new CustomEvent("error"));

                _this.element.dispatchEvent(new CustomEvent("loadend"));

                throw _context.t0;

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 13]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.doFetch = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(url) {
        var response, html;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return fetch(url, _this.optionsForFetch());

              case 2:
                response = _context2.sent;
                _context2.next = 5;
                return response.text();

              case 5:
                html = _context2.sent;
                return _context2.abrupt("return", html);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }();

    return _this;
  }

  _createClass(Autocomplete, [{
    key: "connect",
    value: function connect() {
      this.close();
      if (!this.inputTarget.hasAttribute("autocomplete")) this.inputTarget.setAttribute("autocomplete", "off");
      this.inputTarget.setAttribute("spellcheck", "false");
      this.mouseDown = false;
      this.onInputChange = debounce(this.onInputChange, this.delayValue);
      this.inputTarget.addEventListener("keydown", this.onKeydown);
      this.inputTarget.addEventListener("blur", this.onInputBlur);
      this.inputTarget.addEventListener("input", this.onInputChange);
      this.resultsTarget.addEventListener("mousedown", this.onResultsMouseDown);
      this.resultsTarget.addEventListener("click", this.onResultsClick);

      if (this.inputTarget.hasAttribute("autofocus")) {
        this.inputTarget.focus();
      }

      this.readyValue = true;
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      if (this.hasInputTarget) {
        this.inputTarget.removeEventListener("keydown", this.onKeydown);
        this.inputTarget.removeEventListener("blur", this.onInputBlur);
        this.inputTarget.removeEventListener("input", this.onInputChange);
      }

      if (this.hasResultsTarget) {
        this.resultsTarget.removeEventListener("mousedown", this.onResultsMouseDown);
        this.resultsTarget.removeEventListener("click", this.onResultsClick);
      }
    }
  }, {
    key: "sibling",
    value: function sibling(next) {
      var options = this.options;
      var selected = this.selectedOption;
      var index = options.indexOf(selected);
      var sibling = next ? options[index + 1] : options[index - 1];
      var def = next ? options[0] : options[options.length - 1];
      return sibling || def;
    }
  }, {
    key: "select",
    value: function select(target) {
      var _target$classList;

      var previouslySelected = this.selectedOption;

      if (previouslySelected) {
        var _previouslySelected$c;

        previouslySelected.removeAttribute("aria-selected");

        (_previouslySelected$c = previouslySelected.classList).remove.apply(_previouslySelected$c, _toConsumableArray(this.selectedClassesOrDefault));
      }

      target.setAttribute("aria-selected", "true");

      (_target$classList = target.classList).add.apply(_target$classList, _toConsumableArray(this.selectedClassesOrDefault));

      this.inputTarget.setAttribute("aria-activedescendant", target.id);
      target.scrollIntoView({
        behavior: "smooth",
        block: "nearest"
      });
    }
  }, {
    key: "commit",
    value: function commit(selected) {
      if (selected.getAttribute("aria-disabled") === "true") return;

      if (selected instanceof HTMLAnchorElement) {
        selected.click();
        this.close();
        return;
      }

      var textValue = selected.getAttribute("data-autocomplete-label") || selected.textContent.trim();
      var value = selected.getAttribute("data-autocomplete-value") || textValue;
      this.inputTarget.value = textValue;

      if (this.hasHiddenTarget) {
        this.hiddenTarget.value = value;
        this.hiddenTarget.dispatchEvent(new Event("input"));
        this.hiddenTarget.dispatchEvent(new Event("change"));
      } else {
        this.inputTarget.value = value;
      }

      this.inputTarget.focus();
      this.hideAndRemoveOptions();
      this.element.dispatchEvent(new CustomEvent("autocomplete.change", {
        bubbles: true,
        detail: {
          value: value,
          textValue: textValue,
          selected: selected
        }
      }));
    }
  }, {
    key: "clear",
    value: function clear() {
      this.inputTarget.value = "";
      if (this.hasHiddenTarget) this.hiddenTarget.value = "";
    }
  }, {
    key: "identifyOptions",
    value: function identifyOptions() {
      var _this2 = this;

      var id = 0;
      var optionsWithoutId = this.resultsTarget.querySelectorAll("".concat(optionSelector, ":not([id])"));
      optionsWithoutId.forEach(function (el) {
        el.id = "".concat(_this2.resultsTarget.id, "-option-").concat(id++);
      });
    }
  }, {
    key: "hideAndRemoveOptions",
    value: function hideAndRemoveOptions() {
      this.close();
      this.resultsTarget.innerHTML = null;
    }
  }, {
    key: "buildURL",
    value: function buildURL(query) {
      var url = new URL(this.urlValue, window.location.href);
      var params = new URLSearchParams(url.search.slice(1));
      params.append("q", query);
      url.search = params.toString();
      return url.toString();
    }
  }, {
    key: "replaceResults",
    value: function replaceResults(html) {
      this.resultsTarget.innerHTML = html;
      this.identifyOptions();

      if (!!this.options) {
        this.open();
      } else {
        this.close();
      }
    }
  }, {
    key: "open",
    value: function open() {
      if (this.resultsShown) return;
      this.resultsShown = true;
      this.element.setAttribute("aria-expanded", "true");
      this.element.dispatchEvent(new CustomEvent("toggle", {
        detail: {
          action: "open",
          inputTarget: this.inputTarget,
          resultsTarget: this.resultsTarget
        }
      }));
    }
  }, {
    key: "close",
    value: function close() {
      if (!this.resultsShown) return;
      this.resultsShown = false;
      this.inputTarget.removeAttribute("aria-activedescendant");
      this.element.setAttribute("aria-expanded", "false");
      this.element.dispatchEvent(new CustomEvent("toggle", {
        detail: {
          action: "close",
          inputTarget: this.inputTarget,
          resultsTarget: this.resultsTarget
        }
      }));
    }
  }, {
    key: "resultsShown",
    get: function get() {
      return !this.resultsTarget.hidden;
    },
    set: function set(value) {
      this.resultsTarget.hidden = !value;
    }
  }, {
    key: "options",
    get: function get() {
      return Array.from(this.resultsTarget.querySelectorAll(optionSelector));
    }
  }, {
    key: "selectedOption",
    get: function get() {
      return this.resultsTarget.querySelector(activeSelector);
    }
  }, {
    key: "selectedClassesOrDefault",
    get: function get() {
      return this.hasSelectedClass ? this.selectedClasses : ["active"];
    }
  }, {
    key: "optionsForFetch",
    value: function optionsForFetch() {
      return {
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      }; // override if you need
    }
  }]);

  return Autocomplete;
}(Controller);

Autocomplete.targets = ["input", "hidden", "results"];
Autocomplete.classes = ["selected"];
Autocomplete.values = {
  ready: Boolean,
  submitOnEnter: Boolean,
  url: String,
  minLength: Number,
  delay: {
    type: Number,
    default: 300
  }
};
export { Autocomplete as default };

var debounce = function debounce(fn) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  var timeoutId = null;
  return function () {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(fn, delay);
  };
};

export { Autocomplete };